<!--
 * @Author: chj
 * @Date: 2024-10-10 14:49:19
 * @LastEditors: chj
 * @LastEditTime: 2024-10-22 10:25:19
 * @Description: 请填写简介
-->
<template>
  <section :class="bem({ direction })">
    <div :class="bem('left', { direction })">
      <h3 :class="bem('left-title')">{{ title }}</h3>
      <p :class="bem('left-desc')">{{ content }}</p>
      <div :class="bem('left-more')">
        <router-link to="/alliance/introduction">
          <a-button type="link">更多>></a-button>
        </router-link>
      </div>
    </div>
    <router-link :class="bem('right')" to="/alliance/introduction">
      <div :class="bem('right-item')" :style="`background-image: url(${img})`"></div>
    </router-link>
  </section>
</template>

<script>
import {
  Button as AButton,
} from 'ant-design-vue'
export default {
  name: 'section-item',
  components: {
    AButton
  },
  props: {
    direction: {
      type: String,
      default: 'left'
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="scss" scoped>
.section-item {
  display: flex;
  width: 100%;
  margin-top: 72px;
  margin-bottom: 80px;
  overflow: hidden;
  @include devices(laptop) {
    padding: 0 40px;
  }
  @include devices(phone) {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
  &__left {
    flex: 1 1 auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    &--direction {
      &-left {
        padding-left: 0;
        padding-right: 148px;
        @include devices(laptop) {
          padding-right: 98px;
        }
        @include devices(phone) {
          padding-right: 0;
        }
      }
      &-right {
        order: 2;
        padding-left: 148px;
        padding-right: 0;
        @include devices(laptop) {
          padding-left: 48px;          
        }
        @include devices(phone) {
          order: 0;
          padding-left: 0;
        }
      }
    }
    &-title {
      margin-bottom: 22px;
      font-size: 32px;
      line-height: 45px;
      font-weight: 500;
      color: #1a1a1a;
      @include devices(phone) {
        font-size: 22px;
        line-height: 33px;
      }
    }
    &-desc {
      // margin-bottom: 27px;
      margin: 0;
      font-size: 16px;
      line-height: 26px;
      color: rgba(11, 38, 64, .68);
    }
    &-more {
      display: flex;
      justify-content: flex-end;
    }
  }
  &__right {
    flex: 0 0 50.8%;
    min-height: 466px;
    border-radius: 4px;
    @include devices(phone) {
      min-height: 266px;
    }
    &-item {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: 50%;
      overflow: hidden;
    }
  }
}
</style>
